module.exports = __webpack_public_path__ + "img/icon46.9904b8b9.png";